import { RouterProps, withRouter, WithRouterProps } from "next/router";
import React from "react";
import { LandingContext } from "./context";

const { Provider } = LandingContext;

const getRouterPath = (router?: RouterProps): string =>
  router && router.asPath ? router.asPath : "";

const hasFormOpen = (path: string): boolean => /form/g.test(path);
const hasOffers = (path: string): boolean => /results/g.test(path);

const LandingContextProviderBasic: React.FC<WithRouterProps> = ({ children, router }) => {
  const [defaultFilters, setDefaultFilters] = React.useState();
  React.useEffect(() => {
    if (!router.query || !router.query.filterBy) return;
    const filters = router.query.filterBy.split(",").filter(Boolean);
    setDefaultFilters(filters);
  }, []);

  const path = getRouterPath(router);
  const formOpen = hasFormOpen(path);
  const offersMode = hasOffers(path);
  const formId = router && router.query ? (router.query.formId as string) : undefined;
  const offerId = router && router.query ? (router.query.offerId as string) : undefined;

  return (
    <Provider
      value={{
        formId,
        formOpen,
        offerId,
        offersMode,
        defaultFilters
      }}
    >
      {children}
    </Provider>
  );
};

const LandingContextProvider = withRouter(LandingContextProviderBasic);

export { LandingContextProvider };
